import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const FullTimeJobNoida = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Fulltime Jobs in Noida | Latest Job Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest fulltime jobs in Noida NCR for graduates and students. Apply for IT, Marketing, Finance, HR, and Sales jobs in top companies hiring freshers in Noida."
        />
        <meta
          name="keywords"
          content="fresher jobs in Noida, fulltime jobs in Noida NCR, jobs for freshers in Noida, IT fresher jobs Noida, marketing fresher jobs Noida, graduate jobs Noida, entry-level jobs Noida"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://jobsindelhincr.in/fulltime-jobs-in-noida" />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Fulltime Jobs in Noida – Latest Job Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>Fulltimejobs in Noida</strong>? Explore
          thousands of opportunities in IT, Marketing, Finance, Education,
          Healthcare, and more. Whether you’re a graduate or a student, find your
          first job in Noida NCR today and kickstart your career.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Fulltime in Noida
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>HCL</li>
          <li>Accenture</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Job Categories Available
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Development Jobs in Noida</li>
          <li>Marketing Jobs in Noida</li>
          <li>Finance Jobs in Noida</li>
          <li>Sales Jobs in Noida</li>
          <li>Full-time Jobs in Noida</li>
          <li>Web Development Jobs in Noida</li>
          <li>Digital Marketing Jobs in Noida</li>
          <li>Telecalling Jobs in Noida</li>
          <li>IT Jobs in Noida</li>
          <li>Technical Support Jobs in Noida</li>
          <li>App Development Jobs in Noida</li>
          <li>HR Jobs in Noida</li>
          <li>Fresher Jobs in Noida</li>
          <li>Frontend Developer Jobs in Noida</li>
          <li>Backend Developer Jobs in Noida</li>
          <li>Full Stack Developer Jobs in Noida</li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> – your trusted
          platform to find verified <strong>fulltime job openings</strong> in Noida NCR.
          No registration required – apply directly to companies hiring today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default FullTimeJobNoida;
